import {algoliasearch} from "algoliasearch";
import {ID, KEYWRITE} from "../Constantes";

export const guardarMultiplesRegistros = ({arrObj, col}) => {


    let arr = []
    for (let i = 0; i < arrObj.length; i++) {
        let obj = arrObj[i]
        obj.objectID = obj.id
        arr.push(obj)
    }


    const client = algoliasearch(ID, KEYWRITE);

    return client.saveObjects({
        indexName: col,
        objects: arr
    })



}